<div class="row">
  <div class="col-24 col-sm-6">
    <div class="d-flex flex-column">
      <bitf-search
        (valueChanges)="licenseInstanceSearchText = $event"
        placeholder="Cerca istanza"
        label="Cerca istanza"
        [hasSearchIcon]="true"
        formFieldClass="w-100"
        appearance="fill"
      ></bitf-search>

      <!-- Totale Istanze -->
      <h4 class="font-weight-bold mt-2 mb-1">Totale Istanze</h4>
      <p>{{ licenseInstancePage?.totalElements }}</p>

      <!-- Attive -->
      <h4 class="font-weight-bold mt-2 pt-2 mb-1 border-top">Attive</h4>
      <p>{{ licenseInstancePage?.totalElements }}</p>

      <!-- Riassegnabili -->
      <h4 class="font-weight-bold mt-2 pt-2 mb-1 border-top d-flex justify-content-between align-items-center">
        <span>Riassegnabili</span>
        <div>
          @if (!maxReassignmentsEdit && !isReadonly && authService.hasRole('VOUCHER_CAN_WRITE')) {
          <button mat-icon-button type="button" (click)="onEditMaxReassignments()">
            <mat-icon>edit</mat-icon>
          </button>
          } @if (maxReassignmentsEdit && !isReadonly) {
          <button mat-icon-button type="button" (click)="saveMaxReassignments()" [disabled]="maxReassignmentsForm.invalid">
            <mat-icon>check</mat-icon>
          </button>
          } @if (maxReassignmentsEdit) {
          <button mat-icon-button (click)="undoMaxReassignments()">
            <mat-icon>cancel</mat-icon>
          </button>
          }
        </div>
      </h4>
      <p>
        {{ voucher?.maxReassignments - voucher?.reassignments }}
        - (max: {{ voucher?.maxReassignments }})
      </p>
      <div>
        <form #maxReassignmentsForm="ngForm">
          @if (maxReassignmentsEdit) {
          <div class="d-flex align-items-center">
            <mat-form-field class="w-100">
              <mat-label>Max</mat-label>
              <input
                matInput
                [(ngModel)]="voucher.maxReassignments"
                #maxReassignmentsModel="ngModel"
                name="maxReassignments"
                placeholder="Max"
                [min]="voucher.reassignments"
                [max]="99999"
                required
                validateMin
                [validateMinValue]="1"
                validateMax
                [validateMaxValue]="99999"
              />
              <mat-error appFormFieldError [formFieldModel]="maxReassignmentsModel" [form]="maxReassignmentsForm"></mat-error>
            </mat-form-field>
          </div>
          }
        </form>
      </div>

      <!-- Modalità Scadenza -->
      <h4 class="font-weight-bold mt-2 pt-2 mb-1 border-top">Modalità Scadenza</h4>
      <p>
        <span [hidden]="voucher?.licenseExpirationMode !== 'VOUCHER_EXPIRATION'">Scadenza Voucher</span>
        <span [hidden]="voucher?.licenseExpirationMode === 'VOUCHER_EXPIRATION'">
          Validità ({{ voucher.licenseInstanceValidity }} giorni)
        </span>
      </p>
    </div>
  </div>

  <div class="col-24 col-sm-18">
    @if (canAddLicenseInstance() || true) {
    <div class="d-flex align-items-center justify-content-end">
      <span class="mr-2 mat-caption">Attiva istanza:</span>
      <app-file-uploader
        [showFileList]="false"
        [showDndArea]="true"
        [maxNumberOfFiles]="1"
        [extensions]="['.bin']"
        [showValidationErrorMessage]="true"
        [concatenateMultipleFiles]="false"
        [uploadOnFilesDropped]="true"
        [uploadButtonText]="'Attiva istanza'"
        (startUpload)="onStartUploadMachineId($event)"
      ></app-file-uploader>
      <button mat-stroked-button color="primary" class="ml-3" (click)="refresh()">
        <mat-icon class="mr-2">refresh</mat-icon>
        Aggiorna
      </button>
    </div>
    }

    <app-dynamic-table
      #licenseInstancesTable
      tableClass="shadow-none"
      paginatorClass="shadow-none"
      (fetchData)="fetchLicenseInstances($event)"
      (dataFetched)="licenseInstancesFetched($event)"
      [sorts]="[{ prop: 'createdOn', dir: 'desc' }]"
      [detailRoute]="'/license-instance'"
      [columns]="licenseInstanceCols"
      [showDetailLink]="!isReadonly"
      [showDeleteBtn]="false"
      [searchText]="licenseInstanceSearchText"
      [extraButtons]="isReadonly ? 2 : 1"
    >
      <ng-template #licenseInstanceActiveTmpl let-value="value" let-row="row">
        <mat-chip-option
          class="chip-small text-white"
          [ngClass]="{ 'bg-success': value, 'bg-error': !value }"
          [disableRipple]="true"
          [selectable]="false"
        >
          @if (value) {
          <mat-icon matTooltip="Attiva">check</mat-icon>
          } @if (!value) {
          <mat-icon matTooltip="Non attiva">close</mat-icon>
          }
        </mat-chip-option>
      </ng-template>

      <ng-template #dateTimeTpl let-value="value">
        {{ value | date : 'medium' }}
      </ng-template>

      <ng-template #extraButtonsTmpl let-row="row">
        @if (isReadonly && row.active) {
        <button mat-menu-item (click)="reassign(row)">
          <mat-icon class="mr-2">keyboard_tab</mat-icon>
          Riassegna
        </button>
        } @if (row.machineIdFileExists) {
        <button mat-menu-item (click)="downloadLicense(row)">
          <mat-icon class="mr-2">file_download</mat-icon>
          Scarica licenza
        </button>
        }
      </ng-template>
    </app-dynamic-table>
  </div>
</div>
